// styles
import { AvailabilityEventContainer } from './AvailabilityEvent.styles';

// types
import { CalendarAvailabilityEvent } from '../../Calendar.types';

const AvailabilityEvent = ({ event }: { event: CalendarAvailabilityEvent }) => {
  return (
    <AvailabilityEventContainer
      type={event.type}
      className="availability-event"
      data-source-type={`${event.entitySourceType}`}
      data-entity-id={`${event.entityId}`}
      data-calendar-id={`${event.calendarId}`}
    />
  );
};

export default AvailabilityEvent;
